module.exports = __webpack_public_path__ + "img/wf.8bad3190.svg";